import { render, staticRenderFns } from "./PdfTableComponent.vue?vue&type=template&id=3a853356"
import script from "./PdfTableComponent.vue?vue&type=script&lang=js"
export * from "./PdfTableComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports